module.exports = __webpack_public_path__ + "347725513161b5560d6dd16aed36f4d5.ttf";